import { type FC } from 'react';
import { Button, type ButtonProps } from '@mui/material';
import { AddOutlined } from '@mui/icons-material';

export type Props = {
  children: React.ReactNode;
} & ButtonProps;

export const CreateButton: FC<Props> = ({ children, ...props }) => (
  <Button variant="contained" startIcon={<AddOutlined />} {...props}>
    {children}
  </Button>
);
